// Year core
export function yearCore() {
  const endpoint = '/years';
  const detailId = 'yearId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Year filter
export function yearFilter() {
  const parameter = 'YearId';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.yearId,
        label: row.yearDescription
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
